var Portfolio = /** @class */ (function () {
    function Portfolio(init) {
        this.portfolioId = 1;
        this.portfolioName = "";
        this.expectedReturn = 0;
        this.annualisedStandardDeviation = 0;
        this.expectedDivYield = 0;
        this.targetTic = 0;
        this.assetAllocation = new AssetAllocation();
        Object.assign(this, init);
    }
    return Portfolio;
}());
export { Portfolio };
var AssetAllocation = /** @class */ (function () {
    function AssetAllocation(init) {
        this.localCash = 0;
        this.localBonds = 0;
        this.localEquity = 0;
        this.localProperty = 0;
        this.foreignCash = 0;
        this.foreignBonds = 0;
        this.foreignEquity = 0;
        this.foreignProperty = 0;
        this.africa = 0;
        this.commodity = 0;
        Object.assign(this, init);
    }
    return AssetAllocation;
}());
export { AssetAllocation };
export function getPortfolios() {
    var portfolios = [];
    portfolios.push(new Portfolio({
        portfolioId: 1,
        portfolioName: "Cautious",
        expectedReturn: 0.07,
        annualisedStandardDeviation: 0.04,
        targetTic: 0.0118,
        assetAllocation: new AssetAllocation({
            localEquity: 60,
            localBonds: 40,
        }),
    }));
    portfolios.push(new Portfolio({
        portfolioId: 2,
        portfolioName: "Balanced",
        expectedReturn: 0.1,
        annualisedStandardDeviation: 0.07,
        targetTic: 0.015,
        assetAllocation: new AssetAllocation({
            localCash: 10,
            localBonds: 20,
            localEquity: 50,
            foreignEquity: 20,
        }),
    }));
    portfolios.push(new Portfolio({
        portfolioId: 3,
        portfolioName: "Growth",
        expectedReturn: 0.12,
        annualisedStandardDeviation: 0.09,
        targetTic: 0.025,
        assetAllocation: new AssetAllocation({
            localCash: 0,
            localBonds: 0,
            localEquity: 75,
            foreignEquity: 25,
        }),
    }));
    portfolios.push(new Portfolio({
        portfolioId: 4,
        portfolioName: "Income",
        expectedReturn: 0.06,
        annualisedStandardDeviation: 0.014,
        targetTic: 0.005,
        assetAllocation: new AssetAllocation({
            localCash: 95,
            localBonds: 5,
        }),
    }));
    portfolios.push(new Portfolio({
        portfolioId: 4,
        portfolioName: "Offshore",
        expectedReturn: 0.11,
        annualisedStandardDeviation: 0.014,
        targetTic: 0.015,
        assetAllocation: new AssetAllocation({
            foreignEquity: 95,
            foreignCash: 5,
        }),
    }));
    return portfolios;
}
